import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../lib/auth.js';

export function ProtectedRoute() {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  // Redirecting before the session probe resolves would bounce a signed-in
  // learner to the login page on every hard refresh.
  if (isLoading) {
    return (
      <div
        className="flex min-h-[50vh] items-center justify-center"
        role="status"
        aria-live="polite"
      >
        <Loader2 className="size-6 animate-spin text-slate-400" aria-hidden="true" />
        <span className="sr-only">Loading your session</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
